import { AuthErrorCode } from '@gokrew/models/auth';

export class TerminalAuthError extends Error {}

/**
 * True when an Axios-shaped error's response carries the OTP-challenge
 * terminal error code — i.e. verify/resend will never succeed again for
 * this challenge, no matter how many more times the user tries.
 */
export function isTerminalAuthError(error: unknown): boolean {
  const errorCode = (error as { response?: { data?: { errorCode?: string } } })
    ?.response?.data?.errorCode;
  return errorCode === AuthErrorCode.OtpChallengeTerminal;
}
